module.exports = __webpack_public_path__ + "static/Inbox-scot.a6573253.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Inbox-scot.jpg
// module id = 500
// module chunks = 153228935106781